/**
 * Página de configurações da aplicação.
 *
 * Este componente renderiza a página de configurações, permitindo ao usuário
 * personalizar aspectos da aplicação, como o idioma da interface.
 *
 * @module Settings
 */

import { useTranslation } from 'react-i18next';
import { useHref } from 'react-router-dom';
import ContainerPage from '../../components/ContainerPage/ContainerPage';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import { Main } from './Settings.Styles';

/**
 * Componente funcional que renderiza a página de configurações.
 *
 * Atualmente permite a seleção de idioma da interface, com potencial
 * para expansão com outras configurações no futuro.
 *
 * @returns {JSX.Element} Componente de página de configurações
 */
const Settings = () => {
  // Hook para obter a URL atual
  const href = useHref();

  // Hook de tradução para internacionalização
  const { t } = useTranslation();

  // Extrai o nome da página atual da URL
  const currentPage = href.replace('/', '');

  return (
    <ContainerPage title={currentPage}>
      <Main>
        {/* Seção de seleção de idioma */}
        <div className="input-language">
          <p>{t('Select Language')}</p>
          <LanguageSelector />
        </div>
      </Main>
    </ContainerPage>
  );
};

export default Settings;
